// extracted by mini-css-extract-plugin
export var dividerLine = "_8f-3";
export var itemImage = "_8f-9";
export var lightDivider = "_8f-4";
export var modalContent = "_8f-5";
export var modalContentCompact = "_8f-6";
export var productCard = "_8f-a";
export var productImage = "_8f-b";
export var productImageCompact = "_8f-7";
export var productImagePlaceholder = "_8f-c";
export var productImagePlaceholderCompact = "_8f-8";
export var progressBarBackground = "_8f-1";
export var progressBarContainer = "_8f-0";
export var progressBarFill = "_8f-2";